import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';

const SaleEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL
    const recordId = useParams(); // Assuming you're using React Router
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const [selectedTable, setSelectedTable] = useState("");
    const [dropdownTableOptions, setDropdownTableOptions] = useState([]);
    const [TableOptions, setTableOptions] = useState([]);

    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();

    useEffect(() => {
        fetchDropdownTableOptions();
    }, []);


    const fetchDropdownTableOptions = () => {
        fetchData('TableNameApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownTableOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Table dropdown options:', error);
            });
    };

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const [formData, setFormData] = useState({
        CompanyId: '',
        InvoiceDate: '',
        InvoiceTime: '',
        InvoiceNumber: '',
        TableId: '',
        KOTId: '',
        Amount: '',
        DiscountAmount: '',
        DiscountPer: '',
        NetAmount: '',
        CGSTAmount: '',
        SGSTAmount: '',
        IGSTAmount: '',
        RoundOff: '',
        TotalAmount: '',
        PaymentType: '',
        FinYear: '',
        isSubmit: false,
        TableText: '',
        ModifiedBy: userId,
        PreviousTotalAmount: '',
        PackingCharge: '',
        PreviousPaymentType: '',
        Description: '',
    });
    const [itemdata, setData] = useState([]);


    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString();
        let day = date.getDate().toString();

        // Pad the month and day with leading zeros if needed
        month = month.length === 1 ? `0${month}` : month;
        day = day.length === 1 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    };
    const formatTimeForInput = (timeString) => {
        const time = new Date(`1970-01-01T${timeString}`);
        const hours = time.getHours().toString().padStart(2, '0');
        const minutes = time.getMinutes().toString().padStart(2, '0');
        const seconds = time.getSeconds().toString().padStart(2, '0');

        return `${hours}:${minutes}:${seconds}`;
    };

    useEffect(() => {
        fetchData('SaleApi', `/SaleDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setData(response.response_data.SaleDetails);
                    setSelectedTable(response.response_data.Sale.TableId);
                }

                setFormData((prevData) => ({
                    ...prevData,
                    ModifiedBy: userId,
                }));

            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    const [newRecordData, setNewRecordData] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    // For Item
    const [selectedItem, setSelectedItem] = useState(null);
    const [itemOptions, setItemOptions] = useState([]);
    const [itemdetails, setItemDetails] = useState([]);

    useEffect(() => {

        const fetchItemData = async () => {
            try {
                const response = await fetchData('SaleApi', `/Item/${companyId}`, token);
                const responseData = response.response_data;

                const options = responseData.map((item) => ({
                    label: item.Name,
                    value: item.Id,
                }));

                setItemOptions(options);
                setItemDetails(responseData);
            } catch (error) {
                console.error('Error fetching item data:', error);
            }
        };

        fetchItemData();
    }, [companyId, token]);



    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        setNewRecordData({
            ...newRecordData,
            ItemName: selectedOption ? selectedOption.label : '',
            ItemId: selectedOption ? selectedOption.value : '',
        });

        // Use Array.prototype.find() to find the rate
        const selectedItemId = selectedOption ? selectedOption.value : '';


        const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {
            // Update the rate in the modal data
            setNewRecordData({
                ...newRecordData,
                Rate: selectedItemDetail.Rate, // Assuming Rate is a number
                GSTRate: formData.GstNotApplicable ? 0 : selectedItemDetail.GSTRate,
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
            });
        } else {
            // Handle the case where the item detail is not found
            setNewRecordData({
                ...newRecordData,
                Rate: '0',
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
            });
        }
    };



    const handleInputChange = (event) => {
        const { name, value } = event.target;
        const discountPercentage = parseFloat(formData.discountPercentage) || 0;
        // Update the new record data
        setNewRecordData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        const GstNotApplicable = formData.GstNotApplicable ? formData.GstNotApplicable : false;
        // If the input is for quantity, calculate the amount
        if (name === 'Quantity') {
            const quantity = parseFloat(value) || 0;
            const rate = parseFloat(newRecordData.Rate) || 0;
            const amount = (quantity * rate).toFixed(2);

            const discountAmount = (amount * discountPercentage) / 100;
            const netAmount = (amount - discountAmount).toFixed(2);
            let gstrate = newRecordData.GSTRate;
            if (GstNotApplicable) {
                gstrate = 0;
            }

            const cgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
            const sgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
            const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

            // Update the new record data with the calculated amount
            setNewRecordData((prevData) => ({
                ...prevData,
                Amount: amount,
                DiscountPer: discountPercentage,
                DiscountAmount: discountAmount.toFixed(2),
                NetAmount: netAmount,
                CGSTAmount: cgstAmount,
                SGSTAmount: sgstAmount,
                TotalAmount: totalAmount,
                GSTRate: gstrate,
            }));
        }
    };


    const addRecord = () => {

        if (!newRecordData.ItemName && !newRecordData.Quantity) {
            return;
        }
        const updatedItemData = [...itemdata, newRecordData];
        setData(updatedItemData);
        setNewRecordData([]);
        toggleModal();

        // Update the totals based on the updatedItemData
        const invAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
        const netAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
        const cgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
        const sgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
        const igstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount) || 0, 0);
        const discAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
        const additionalDiscount = parseFloat(formData.AdditionalDiscount) || 0;

        totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount, additionalDiscount);
    };

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        const GstNotApplicable = formData.GstNotApplicable || false;

        setFormData((prevData) => {
            let updatedData = {
                ...prevData,
                [name]: type === 'checkbox' ? !prevData[name] : value,
                ModifiedBy: userId
            };
            const totalAmount = parseFloat(updatedData.TotalAmount) || 0;
            if (name === "PaymentType") {

                var ptype = value;
                if (ptype === "1") {
                    updatedData.CashAmount = totalAmount;
                    updatedData.CardAmount = 0;
                    updatedData.UPIAmount = 0;
                }
                else if (ptype === "2") {
                    updatedData.CardAmount = totalAmount;
                    updatedData.CashAmount = 0;
                    updatedData.UPIAmount = 0;
                }
                else if (ptype === "3") {
                    updatedData.UPIAmount = totalAmount;
                    updatedData.CashAmount = 0;
                    updatedData.CardAmount = 0;
                }

            }
            // Convert numeric values

            let cashAmount = parseFloat(updatedData.CashAmount) || 0;
            let cardAmount = parseFloat(updatedData.CardAmount) || 0;
            let upiAmount = parseFloat(updatedData.UPIAmount) || 0;

            // Handle payment method constraints
            if (name === "CashAmount") {
                const maxCashAmount = totalAmount - (cardAmount + upiAmount);
                updatedData.CashAmount = Math.min(cashAmount, maxCashAmount).toFixed(2);
            }
            else if (name === "CardAmount") {
                const maxCardAmount = totalAmount - (cashAmount + upiAmount);
                updatedData.CardAmount = Math.min(cardAmount, maxCardAmount).toFixed(2);
            }
            else if (name === "UPIAmount") {
                const maxUpiAmount = totalAmount - (cashAmount + cardAmount);
                updatedData.UPIAmount = Math.min(upiAmount, maxUpiAmount).toFixed(2);
            }

            // Handle discount calculations
            if (name === "DiscountPer" || name === "DiscountAmount") {
                const discountPercentage = name === "DiscountPer" ? (parseFloat(value) || 0) : ((parseFloat(value) || 0) / parseFloat(formData.Amount || 1)) * 100;
                const additionalDiscount = parseFloat(updatedData.AdditionalDiscount) || 0;

                updatedData.DiscountPer = discountPercentage.toFixed(2);

                const updatedItemData = itemdata.map((item) => {
                    const amount = parseFloat(item.Amount) || 0;
                    const discountAmount = (amount * discountPercentage) / 100;
                    const netAmount = (amount - discountAmount).toFixed(2);
                    let gstrate = GstNotApplicable ? 0 : item.GSTRate;

                    const cgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const sgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

                    return {
                        ...item,
                        DiscountPer: discountPercentage.toFixed(2),
                        DiscountAmount: discountAmount.toFixed(2),
                        NetAmount: netAmount,
                        CGSTAmount: cgstAmount,
                        SGSTAmount: sgstAmount,
                        TotalAmount: totalAmount,
                        GSTRate: gstrate
                    };
                });

                setData(updatedItemData);

                // Recalculate totals
                const invAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
                const netAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
                const cgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
                const sgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
                const igstAmount = updatedItemData.reduce((sum, item) => sum + (parseFloat(item.IGSTAmount) || 0), 0);
                const discAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

                totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount, additionalDiscount);
            }

            // Handle additional discount updates
            if (name === "AdditionalDiscount") {
                const additionalDiscount = parseFloat(value) || 0;

                const invAmount = itemdata.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
                const netAmount = itemdata.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
                const cgstAmount = itemdata.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
                const sgstAmount = itemdata.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
                const igstAmount = itemdata.reduce((sum, item) => sum + (parseFloat(item.IGSTAmount) || 0), 0);
                const discAmount = itemdata.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

                totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount, additionalDiscount);
            }

            return updatedData;
        });
    };


    const handleSubmit = (event) => {
        event.preventDefault();


        if (parseFloat(formData.CashAmount) + parseFloat(formData.CardAmount) + parseFloat(formData.UPIAmount) !== parseFloat(formData.TotalAmount)) {
            setErrorMessage("The sum of Cash, Card, and UPI amounts must equal the Total Amount.");
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
        }));

        const CreateData = {
            Sale: formData,
            SaleDetails: itemdata
        };

        // Validate form data here if needed

        updateData('SaleApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/SaleIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...itemdata];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setData(updatedRecords); // Update the state to reflect the removed record 

            let invAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            let netAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
            let cgstAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            let sgstAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            let igstAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.IGSTAmount) || 0, 0);
            let discAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            let additionalDiscount = parseFloat(formData.AdditionalDiscount) || 0;

            totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount, additionalDiscount);
        }

    };

    const totalCalculation = (invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount, additionalDiscount) => {
        const packingCharge = parseFloat(formData.PackingCharge) || 0;
        let amount = parseFloat(invAmount);
        let netamount = parseFloat(netAmount);
        let netAmt = netAmount + parseFloat(cgstAmount) + parseFloat(sgstAmount) + parseFloat(igstAmount) + packingCharge;
        let roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmount = (netAmt + roundOffValue - additionalDiscount).toFixed(2);
        let cashAmount = parseFloat(formData.CashAmount) || 0;
        let cardAmount = parseFloat(formData.CardAmount) || 0;
        let upiAmount = parseFloat(formData.UPIAmount) || 0;

        // 🔹 Apply PaymentType logic dynamically
        if (formData.PaymentType) {
            const ptype = formData.PaymentType.toString();
            if (ptype === "1") {
                cashAmount = totalAmount;
                cardAmount = 0;
                upiAmount = 0;
            } else if (ptype === "2") {
                cardAmount = totalAmount;
                cashAmount = 0;
                upiAmount = 0;
            } else if (ptype === "3") {
                upiAmount = totalAmount;
                cashAmount = 0;
                cardAmount = 0;
            }
        }


        setFormData((prevData) => ({
            ...prevData,
            Amount: amount.toFixed(2),
            NetAmount: netamount.toFixed(2),
            TotalAmount: totalAmount,
            DiscountAmount: discAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            CGSTAmount: cgstAmount.toFixed(2),
            SGSTAmount: sgstAmount.toFixed(2),
            IGSTAmount: igstAmount.toFixed(2),
            CashAmount: cashAmount,
            CardAmount: cardAmount,
            UPIAmount: upiAmount,
            ModifiedBy: userId,
        }));
    };

    const handleCalculation = (e, index) => {
        const { name, value } = e.target;
        const discountPercentage = parseFloat(formData.DiscountPer) || 0;
        const GstNotApplicable = formData.GstNotApplicable ? formData.GstNotApplicable : false;

        const updatedItemData = itemdata.map((item, i) => {
            if (i === index) {
                if (name === 'Quantity') {
                    const quantity = parseFloat(value) || 0;
                    const rate = parseFloat(item.Rate) || 0;
                    const amount = (quantity * rate).toFixed(2);
                    const discountAmount = (amount * discountPercentage) / 100;
                    const netAmount = (amount - discountAmount).toFixed(2);
                    let gstrate = item.GSTRate;
                    if (GstNotApplicable) {
                        gstrate = 0;
                    }

                    const cgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const sgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

                    return {
                        ...item,
                        Quantity: quantity,
                        Amount: amount,
                        DiscountPer: discountPercentage.toFixed(2),
                        DiscountAmount: discountAmount.toFixed(2),
                        NetAmount: netAmount,
                        CGSTAmount: cgstAmount,
                        SGSTAmount: sgstAmount,
                        TotalAmount: totalAmount,
                        GSTRate: gstrate,
                    };
                } else if (name === 'Rate') {
                    const rate = parseFloat(value) || 0;
                    const quantity = parseFloat(item.Quantity) || 0;
                    const amount = (quantity * rate).toFixed(2);
                    const discountAmount = (amount * discountPercentage) / 100;
                    const netAmount = (amount - discountAmount).toFixed(2);
                    let gstrate = item.GSTRate;
                    if (GstNotApplicable) {
                        gstrate = 0;
                    }

                    const cgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const sgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

                    return {
                        ...item,
                        Rate: rate,
                        Amount: amount,
                        DiscountPer: discountPercentage.toFixed(2),
                        DiscountAmount: discountAmount.toFixed(2),
                        NetAmount: netAmount,
                        CGSTAmount: cgstAmount,
                        SGSTAmount: sgstAmount,
                        TotalAmount: totalAmount,
                        GSTRate: gstrate,
                    };
                }

                // --- Handle Description ---
                else if (name === 'description') {
                    return {
                        ...item,
                        description: value, // just update text, no recalculation
                    };
                }
            }
            return item;
        });

        setData(updatedItemData);

        // Update the totals based on the updatedItemData
        const invAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
        const netAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
        const cgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
        const sgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
        const igstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount) || 0, 0);
        const discAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
        const additionalDiscount = parseFloat(formData.AdditionalDiscount) || 0;

        totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount, additionalDiscount);
    };



    return (
        <Fragment>
            <div className="se-wrapper">

                <style>
                    {`
                        @keyframes slideIn {
                            from {
                                opacity: 0;
                                transform: translateY(-10px);
                            }
                            to {
                                opacity: 1;
                                transform: translateY(0);
                            }
                        }
                        
                        @keyframes pulse {
                            0%, 100% {
                                transform: scale(1);
                            }
                            50% {
                                transform: scale(1.05);
                            }
                        }
                        
                        .payment-button {
                            flex: 1;
                            min-width: 85px;
                            padding: 6px 10px;
                            border: 2px solid #e5e7eb;
                            border-radius: 8px;
                            background: #ffffff;
                            cursor: pointer;
                            transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: center;
                            gap: 6px;
                            position: relative;
                            overflow: hidden;
                            box-shadow: 0 1px 3px rgba(0,0,0,0.08);
                        }
                        
                        .payment-button::before {
                            content: '';
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            background: linear-gradient(135deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0) 100%);
                            opacity: 0;
                            transition: opacity 0.3s ease;
                        }
                        
                        .payment-button:hover {
                            transform: translateY(-2px);
                            box-shadow: 0 6px 20px rgba(0,0,0,0.12);
                        }
                        
                        .payment-button:hover::before {
                            opacity: 1;
                        }
                        
                        .payment-button.selected {
                            border-width: 2px;
                            box-shadow: 0 8px 24px rgba(0,0,0,0.15);
                            animation: pulse 0.5s ease;
                        }
                        
                        .payment-button.cash {
                            border-color: #d1fae5;
                        }
                        
                        .payment-button.cash.selected {
                            border-color: #10b981;
                            background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
                            box-shadow: 0 8px 24px rgba(16, 185, 129, 0.25);
                        }
                        
                        .payment-button.card {
                            border-color: #dbeafe;
                        }
                        
                        .payment-button.card.selected {
                            border-color: #3b82f6;
                            background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                            box-shadow: 0 8px 24px rgba(59, 130, 246, 0.25);
                        }
                        
                        .payment-button.upi {
                            border-color: #ede9fe;
                        }
                        
                        .payment-button.upi.selected {
                            border-color: #8b5cf6;
                            background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%);
                            box-shadow: 0 8px 24px rgba(139, 92, 246, 0.25);
                        }
                        
                        .payment-button .icon-wrapper {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            transition: all 0.3s ease;
                            font-size: 16px;
                            line-height: 1;
                        }
                        
                        .payment-button.selected .icon-wrapper {
                            transform: scale(1.1);
                            filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15));
                        }
                        
                        .payment-button .label {
                            font-weight: 600;
                            font-size: 11px;
                            color: #6b7280;
                            letter-spacing: 0.3px;
                            text-transform: uppercase;
                            transition: all 0.3s ease;
                            white-space: nowrap;
                        }
                        
                        .payment-button.selected .label {
                            color: #111827;
                            font-weight: 700;
                        }
                        
                        .payment-button .checkmark {
                            position: absolute;
                            top: 4px;
                            right: 4px;
                            width: 18px;
                            height: 18px;
                            border-radius: 50%;
                            background: linear-gradient(135deg, #10b981 0%, #059669 100%);
                            color: white;
                            display: none;
                            align-items: center;
                            justify-content: center;
                            font-size: 11px;
                            font-weight: bold;
                            box-shadow: 0 2px 6px rgba(16, 185, 129, 0.4);
                        }
                        
                        .payment-button.selected .checkmark {
                            display: flex;
                            animation: slideIn 0.3s ease;
                        }
                        
                        .modern-card {
                            background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
                            border-radius: 16px;
                            padding: 12px 20px;
                            box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 4px 12px rgba(0,0,0,0.04);
                            margin-bottom: 8px;
                            margin-top: 4px;
                            border: 1px solid rgba(226, 232, 240, 0.8);
                        }
                        
                        .modern-input {
                            border: 1.5px solid #e5e7eb;
                            border-radius: 6px;
                            transition: all 0.2s ease;
                            font-size: 13px;
                        }
                        
                        .modern-input:focus {
                            border-color: #3b82f6;
                            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
                            outline: none;
                        }
                        
                        .modern-input:hover:not(:focus):not([readonly]) {
                            border-color: #cbd5e1;
                        }
                        
                        .modern-select {
                            border: 1.5px solid #e5e7eb;
                            border-radius: 6px;
                            transition: all 0.2s ease;
                            font-size: 13px;
                        }
                        
                        .modern-select:focus {
                            border-color: #3b82f6;
                            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
                            outline: none;
                        }
                        
                        .action-button {
                            border-radius: 8px;
                            font-weight: 600;
                            text-transform: none;
                            padding: 8px 20px;
                            transition: all 0.2s ease;
                            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                        }
                        
                        .action-button:hover {
                            transform: translateY(-1px);
                            box-shadow: 0 6px 16px rgba(0,0,0,0.15);
                        }
                        
                        .action-button:active {
                            transform: translateY(0);
                        }
                        
                        .field-label {
                            display: block;
                            font-size: 11px;
                            font-weight: 600;
                            color: #475569;
                            margin-bottom: 6px;
                            text-transform: uppercase;
                            letter-spacing: 0.5px;
                        }
                        
                        .amount-highlight {
                            background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                            border: 2px solid #3b82f6 !important;
                        }
                        
                        .total-amount-field {
                            min-width: 0;
                        }
                        
                        .table thead {
                            background-color: #2c3e50 !important;
                        }
                        
                        .table thead tr {
                            background-color: #2c3e50 !important;
                        }
                        
                        .table thead th {
                            background-color: #2c3e50 !important;
                        }
                        
                        @keyframes modalFadeIn {
                            from {
                                opacity: 0;
                                transform: scale(0.95);
                            }
                            to {
                                opacity: 1;
                                transform: scale(1);
                            }
                        }
                        
                        .modal-backdrop {
                            backdrop-filter: blur(4px);
                            animation: fadeIn 0.2s ease;
                        }
                        
                        @keyframes fadeIn {
                            from { opacity: 0; }
                            to { opacity: 1; }
                        }
                        
                        .modal-content {
                            animation: modalFadeIn 0.3s ease;
                            background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
                            border: 1px solid #e2e8f0;
                        }
                        
                        .modal-header {
                            background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
                            margin: -32px -32px 20px -32px;
                            padding: 14px 32px;
                            border-radius: 16px 16px 0 0;
                            border-bottom: 2px solid #cbd5e1;
                        }

                        /* ── Layout helpers ── */
                        .se-wrapper { width: 95%; margin: 4px auto 0; }

                        .se-row {
                            display: flex;
                            flex-wrap: nowrap;
                            gap: 10px;
                            margin-bottom: 10px;
                        }
                        .se-row > .se-field { flex: 1 1 0; min-width: 0; }

                        /* Total Amount gets 1.6x share */
                        .se-field-total { flex: 1.6 1 0 !important; min-width: 0; }

                        /* Cash/Card/UPI each equal share */
                        .se-field-pay { flex: 1 1 0; min-width: 0; }

                        /* ── Tablet (≤900px): wrap amounts 4-per-row ── */
                        @media (max-width: 900px) {
                            .se-wrapper { width: 100%; }
                            .se-row { flex-wrap: wrap; }
                            .se-row > .se-field { flex: 0 0 calc(25% - 8px); }
                            .se-field-total { flex: 0 0 calc(50% - 8px) !important; }
                            .se-field-pay { flex: 0 0 calc(33.33% - 8px) !important; }
                            .modern-card { padding: 10px 14px !important; }
                        }

                        /* ── Phone (≤600px): 2-per-row, readable layout ── */
                        @media (max-width: 600px) {
                            .se-wrapper { width: 100% !important; }
                            .se-row { flex-wrap: wrap; gap: 8px; }
                            .se-row > .se-field { flex: 0 0 calc(50% - 4px) !important; }
                            .se-field-total { flex: 0 0 calc(50% - 4px) !important; }
                            .se-field-pay { flex: 0 0 calc(33.33% - 6px) !important; }
                            .se-row > .se-field-description { flex: 0 0 100% !important; }
                            .field-label { font-size: 10px !important; }
                            .se-row input, .se-row select { font-size: 12px !important; }
                            .payment-button { min-width: 50px !important; padding: 4px 4px !important; }
                            .payment-button .label { font-size: 9px !important; }
                            .modern-card { padding: 8px 10px !important; border-radius: 10px !important; }
                            .header-bar { flex-wrap: wrap; gap: 6px !important; }
                            .header-title { font-size: 16px !important; width: 100%; }
                            .header-actions { display: flex; flex-wrap: wrap; gap: 6px; width: 100%; }
                            .header-actions .MuiButton-root { flex: 1; min-width: 70px; font-size: 11px !important; height: 30px !important; margin-left: 0 !important; }
                        }
                    `}
                </style>

                <div style={{ display: 'flex', alignItems: 'center', padding: '4px 0', marginBottom: '12px', flexWrap: 'wrap', gap: '6px' }} className="header-bar">
                    <h6 className="header-title" style={{
                        fontFamily: 'system-ui, -apple-system, sans-serif',
                        color: '#0f172a',
                        fontSize: '22px',
                        fontWeight: '800',
                        margin: 0,
                        letterSpacing: '-0.5px',
                        flexGrow: 1
                    }}>
                        <span style={{
                            background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text'
                        }}>Sale</span> - Edit
                    </h6>
                    <div className="header-actions" style={{ display: 'flex', alignItems: 'center' }}>
                    <Button
                        variant="contained"
                        className="action-button"
                        style={{
                            marginLeft: '8px',
                            backgroundColor: '#f59e0b',
                            color: 'white',
                            height: '34px',
                            fontSize: '13px'
                        }}
                        onClick={toggleModal}
                    >
                        + Add Item
                    </Button>
                    <Button
                        variant="contained"
                        className="action-button"
                        style={{
                            marginLeft: '8px',
                            backgroundColor: '#10b981',
                            color: 'white',
                            height: '34px',
                            fontSize: '13px'
                        }}
                        onClick={handleSubmit}
                    >
                        Update Sale
                    </Button>

                    <Button
                        variant="contained"
                        className="action-button"
                        color="error"
                        component={Link}
                        to="/SaleIndex"
                        style={{ marginLeft: '8px', height: '34px', fontSize: '13px' }}
                    >
                        Cancel
                    </Button>
                    </div>
                </div>


                {errorMessage && (
                    <div style={{
                        padding: '12px 16px',
                        backgroundColor: '#fee2e2',
                        border: '1px solid #fca5a5',
                        borderRadius: '8px',
                        color: '#991b1b',
                        marginBottom: '16px',
                        fontWeight: '500'
                    }}>
                        {errorMessage}
                    </div>
                )}
                {successMessage && successMessage.trim() && (
                    <div style={{
                        padding: '12px 16px',
                        backgroundColor: '#d1fae5',
                        border: '1px solid #6ee7b7',
                        borderRadius: '8px',
                        color: '#065f46',
                        marginBottom: '16px',
                        fontWeight: '500'
                    }}>
                        {successMessage}
                    </div>
                )}

                <div className="modern-card">
                    {/* Row 1: Invoice No, Date, Time, Table, Payment Type */}
                    <div className="se-row">
                        <div className="se-field">
                            <label className="field-label">Invoice No <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={formData.InvoiceNumber} onChange={handleChange} type="text" placeholder="INV-0000" readOnly style={{ width: '100%', height: '32px', backgroundColor: '#f9fafb', fontWeight: '500', padding: '0 8px', boxSizing: 'border-box' }} />
                        </div>
                        <div className="se-field">
                            <label className="field-label">Invoice Date <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={formatDateForInput(formData.InvoiceDate)} onChange={handleChange} type="date" readOnly style={{ width: '100%', height: '32px', backgroundColor: '#f9fafb', fontWeight: '500', padding: '0 8px', boxSizing: 'border-box' }} />
                        </div>
                        <div className="se-field">
                            <label className="field-label">Invoice Time <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={formatTimeForInput(formData.InvoiceTime)} onChange={handleChange} type="time" readOnly style={{ width: '100%', height: '32px', backgroundColor: '#f9fafb', fontWeight: '500', padding: '0 8px', boxSizing: 'border-box' }} />
                        </div>
                        <div className="se-field">
                            <label className="field-label">Table Name <span style={{ color: '#ef4444' }}>*</span></label>
                            <select className="modern-select" style={{ width: '100%', height: '32px', fontWeight: '500', padding: '0 8px', boxSizing: 'border-box' }} value={selectedTable}
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setSelectedTable(selectedValue);
                                    const selectedTableRecord = dropdownTableOptions.find(c => c.Id === selectedValue);
                                    const gstNotApplicable = selectedTableRecord ? selectedTableRecord.GstNotApplicable : false;
                                    setFormData(prev => ({ ...prev, TableId: selectedValue, GstNotApplicable: gstNotApplicable }));
                                }}>
                                <option value="">Select Table</option>
                                {dropdownTableOptions.map(c => <option key={c.Id} value={c.Id}>{c.Name}</option>)}
                            </select>
                        </div>
                        <div className="se-field">
                            <label className="field-label">Payment Type <span style={{ color: '#ef4444' }}>*</span></label>
                            <div style={{ display: 'flex', gap: '6px', height: '32px' }}>
                                <div className={`payment-button cash ${formData.PaymentType.toString() === '1' ? 'selected' : ''}`} onClick={() => handleChange({ target: { name: 'PaymentType', value: '1' } })}>
                                    <div className="checkmark">✓</div>
                                    <div className="icon-wrapper">💵</div>
                                    <span className="label">Cash</span>
                                </div>
                                <div className={`payment-button card ${formData.PaymentType.toString() === '2' ? 'selected' : ''}`} onClick={() => handleChange({ target: { name: 'PaymentType', value: '2' } })}>
                                    <div className="checkmark">✓</div>
                                    <div className="icon-wrapper">💳</div>
                                    <span className="label">Card</span>
                                </div>
                                <div className={`payment-button upi ${formData.PaymentType.toString() === '3' ? 'selected' : ''}`} onClick={() => handleChange({ target: { name: 'PaymentType', value: '3' } })}>
                                    <div className="checkmark">✓</div>
                                    <div className="icon-wrapper">📱</div>
                                    <span className="label">UPI</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Row 2: Amount fields */}
                    <div className="se-row">
                        <div className="se-field">
                            <label className="field-label">Amount <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={Number(formData.Amount).toFixed(2)} onChange={handleChange} type="number" placeholder="0.00" readOnly style={{ width: '100%', height: '32px', backgroundColor: '#f9fafb', fontWeight: '600', textAlign: 'right', padding: '0 8px', boxSizing: 'border-box' }} />
                        </div>
                        <div className="se-field">
                            <label className="field-label">Discount % <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={Number(formData.DiscountPer).toFixed(2)} onChange={handleChange} name="DiscountPer" type="number" placeholder="0.00" style={{ width: '100%', height: '32px', fontWeight: '600', textAlign: 'right', padding: '0 8px', boxSizing: 'border-box' }} />
                        </div>
                        <div className="se-field">
                            <label className="field-label">Discount Amt <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={Number(formData.DiscountAmount).toFixed(2)} onChange={handleChange} name="DiscountAmount" type="number" placeholder="0.00" readOnly style={{ width: '100%', height: '32px', backgroundColor: '#f9fafb', fontWeight: '600', textAlign: 'right', padding: '0 8px', boxSizing: 'border-box' }} />
                        </div>
                        <div className="se-field">
                            <label className="field-label">Addt'l. Disc. <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={Number(formData.AdditionalDiscount).toFixed(2)} onChange={handleChange} name="AdditionalDiscount" type="number" placeholder="0.00" style={{ width: '100%', height: '32px', fontWeight: '600', textAlign: 'right', padding: '0 8px', boxSizing: 'border-box' }} />
                        </div>
                        <div className="se-field">
                            <label className="field-label">Net Amount <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={Number(formData.NetAmount).toFixed(2)} name="NetAmount" onChange={handleChange} type="number" placeholder="0.00" readOnly style={{ width: '100%', height: '32px', backgroundColor: '#f9fafb', fontWeight: '600', textAlign: 'right', padding: '0 8px', boxSizing: 'border-box' }} />
                        </div>
                        <div className="se-field">
                            <label className="field-label">CGST <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={Number(formData.CGSTAmount).toFixed(2)} onChange={handleChange} name="CGSTAmount" type="number" placeholder="0.00" readOnly style={{ width: '100%', height: '32px', backgroundColor: '#f9fafb', fontWeight: '600', textAlign: 'right', padding: '0 8px', boxSizing: 'border-box' }} />
                        </div>
                        <div className="se-field">
                            <label className="field-label">SGST <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={Number(formData.SGSTAmount).toFixed(2)} onChange={handleChange} name="SGSTAmount" type="number" placeholder="0.00" readOnly style={{ width: '100%', height: '32px', backgroundColor: '#f9fafb', fontWeight: '600', textAlign: 'right', padding: '0 8px', boxSizing: 'border-box' }} />
                        </div>
                        <div className="se-field">
                            <label className="field-label">IGST <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={Number(formData.IGSTAmount).toFixed(2)} onChange={handleChange} name="IGSTAmount" type="number" placeholder="0.00" readOnly style={{ width: '100%', height: '32px', backgroundColor: '#f9fafb', fontWeight: '600', textAlign: 'right', padding: '0 8px', boxSizing: 'border-box' }} />
                        </div>
                    </div>

                    {/* Row 3: Totals + Payment amounts */}
                    <div className="se-row">
                        <div className="se-field">
                            <label className="field-label">Packing <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={Number(formData.PackingCharge).toFixed(2)} onChange={handleChange} type="number" placeholder="0.00" name="PackingCharge" readOnly style={{ width: '100%', height: '32px', backgroundColor: '#f9fafb', fontWeight: '600', textAlign: 'right', padding: '0 8px', boxSizing: 'border-box' }} />
                        </div>
                        <div className="se-field">
                            <label className="field-label">Round Off <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={Number(formData.RoundOff).toFixed(2)} onChange={handleChange} type="number" placeholder="0.00" readOnly style={{ width: '100%', height: '32px', backgroundColor: '#f9fafb', fontWeight: '600', textAlign: 'right', padding: '0 8px', boxSizing: 'border-box' }} />
                        </div>
                        <div className="se-field se-field-total">
                            <label className="field-label">Total Amount <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input amount-highlight" value={Number(formData.TotalAmount).toFixed(2)} onChange={handleChange} type="number" placeholder="0.00" readOnly style={{ width: '100%', height: '32px', fontWeight: '700', fontSize: '15px', color: '#1e40af', textAlign: 'right', padding: '0 8px', boxSizing: 'border-box' }} />
                        </div>
                        <div className="se-field se-field-pay">
                            <label className="field-label">💵 Cash <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={Number(formData.CashAmount).toFixed(2)} onChange={handleChange} type="number" placeholder="0.00" name="CashAmount" style={{ width: '100%', height: '32px', fontWeight: '700', fontSize: '14px', color: '#059669', textAlign: 'right', padding: '0 8px', boxSizing: 'border-box', borderColor: '#10b981', borderWidth: '2px' }} />
                        </div>
                        <div className="se-field se-field-pay">
                            <label className="field-label">💳 Card <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={Number(formData.CardAmount).toFixed(2)} onChange={handleChange} type="number" placeholder="0.00" name="CardAmount" style={{ width: '100%', height: '32px', fontWeight: '700', fontSize: '14px', color: '#2563eb', textAlign: 'right', padding: '0 8px', boxSizing: 'border-box', borderColor: '#3b82f6', borderWidth: '2px' }} />
                        </div>
                        <div className="se-field se-field-pay">
                            <label className="field-label">📱 UPI <span style={{ color: '#ef4444' }}>*</span></label>
                            <input className="modern-input" value={Number(formData.UPIAmount).toFixed(2)} onChange={handleChange} type="number" placeholder="0.00" name="UPIAmount" style={{ width: '100%', height: '32px', fontWeight: '700', fontSize: '14px', color: '#7c3aed', textAlign: 'right', padding: '0 8px', boxSizing: 'border-box', borderColor: '#8b5cf6', borderWidth: '2px' }} />
                        </div>
                        <div className="se-field se-field-description" style={{ flex: '2 1 0', minWidth: 0 }}>
                            <label className="field-label">Description</label>
                            <input className="modern-input" value={formData.Description || ''} onChange={handleChange} type="text" name="Description" placeholder="Enter description..." style={{ width: '100%', height: '32px', fontWeight: '500', padding: '0 8px', boxSizing: 'border-box' }} />
                        </div>
                    </div>

                </div >
                <div className="modern-card" style={{ marginTop: '4px' }}>
                    <div style={{ marginBottom: '8px' }}>
                        {isModalOpen && (
                            <div className="fixed inset-0 flex items-center justify-center z-50 modal-backdrop" style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, backgroundColor: 'rgba(15, 23, 42, 0.6)' }}>
                                <div className="modal-content" style={{ padding: '32px', borderRadius: '16px', width: '700px', maxWidth: '90vw', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)' }}>
                                    <div className="modal-header">
                                        <h6 style={{ textAlign: 'center', fontFamily: 'system-ui, -apple-system, sans-serif', color: '#1e293b', fontSize: '15px', fontWeight: '700', margin: 0, letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                                            ➕ Add New Item
                                        </h6>
                                    </div>
                                    <div style={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
                                        <div style={{ flex: 3 }}>
                                            <label className="field-label" style={{ marginBottom: '8px' }}>Item Name <span style={{ color: '#ef4444' }}>*</span></label>
                                            <Select options={itemOptions} value={selectedItem} onChange={handleItemSelect} placeholder="Select an item..."
                                                styles={{
                                                    control: (base, state) => ({ ...base, borderRadius: '8px', borderColor: state.isFocused ? '#3b82f6' : '#e5e7eb', borderWidth: '1.5px', minHeight: '38px', boxShadow: state.isFocused ? '0 0 0 3px rgba(59,130,246,0.1)' : 'none', '&:hover': { borderColor: '#3b82f6' } }),
                                                    menu: (base) => ({ ...base, borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', border: '1px solid #e5e7eb' }),
                                                    option: (base, state) => ({ ...base, backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#eff6ff' : 'white', color: state.isSelected ? 'white' : '#1f2937', cursor: 'pointer' })
                                                }}
                                            />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <label className="field-label" style={{ marginBottom: '8px' }}>Quantity <span style={{ color: '#ef4444' }}>*</span></label>
                                            <input className="modern-input" type="number" name="Quantity" placeholder="0" value={newRecordData.Quantity} onChange={handleInputChange} style={{ width: '100%', height: '38px', fontWeight: '600', fontSize: '14px', textAlign: 'right', padding: '0 8px', boxSizing: 'border-box' }} />
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', paddingTop: '16px', borderTop: '1px solid #e5e7eb' }}>
                                        <Button variant="contained" className="action-button" style={{ backgroundColor: '#6b7280', color: 'white', height: '38px', minWidth: '100px' }} onClick={toggleModal}>Cancel</Button>
                                        <Button variant="contained" className="action-button" style={{ background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', color: 'white', height: '38px', minWidth: '120px', fontWeight: '600' }} onClick={addRecord}>✓ Add Item</Button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div style={{ width: '100%', marginTop: '8px', overflowX: 'auto' }}>
                            <TableContainer component={Paper} style={{ borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', maxHeight: '320px', overflowY: 'auto', overflowX: 'auto' }}>
                                <table className="table" style={{ borderCollapse: 'separate', borderSpacing: 0, width: '100%', minWidth: '600px' }}>
                                    <thead style={{ backgroundColor: '#2c3e50', position: 'sticky', top: 0, zIndex: 1 }}>
                                        <tr style={{
                                            backgroundColor: '#2c3e50',
                                            borderBottom: '2px solid #1a252f'
                                        }}>
                                            <th style={{ padding: '10px 12px', fontWeight: '700', color: '#ffffff', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px', borderRight: '1px solid #34495e', backgroundColor: '#2c3e50', whiteSpace: 'nowrap' }}>Item Name</th>
                                            <th style={{ padding: '10px 12px', textAlign: 'center', fontWeight: '700', color: '#ffffff', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px', borderRight: '1px solid #34495e', backgroundColor: '#2c3e50' }}>Quantity</th>
                                            <th style={{ padding: '10px 12px', textAlign: 'center', fontWeight: '700', color: '#ffffff', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px', borderRight: '1px solid #34495e', backgroundColor: '#2c3e50' }}>Rate</th>
                                            <th style={{ padding: '10px 12px', textAlign: 'center', fontWeight: '700', color: '#ffffff', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px', borderRight: '1px solid #34495e', backgroundColor: '#2c3e50' }}>Disc %</th>
                                            <th style={{ padding: '10px 12px', textAlign: 'center', fontWeight: '700', color: '#ffffff', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px', borderRight: '1px solid #34495e', backgroundColor: '#2c3e50' }}>Total</th>
                                            <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: '700', color: '#ffffff', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px', borderRight: '1px solid #34495e', backgroundColor: '#2c3e50' }}>Remark</th>
                                            <th style={{ padding: '10px 12px', fontWeight: '700', color: '#ffffff', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px', backgroundColor: '#2c3e50' }}>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {itemdata.map((invdetail, index) => (
                                            <tr key={index} style={{
                                                width: '100%',
                                                borderBottom: '1px solid #e2e8f0',
                                                transition: 'background-color 0.2s',
                                                backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc'
                                            }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#eff6ff'}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#f8fafc'}
                                            >
                                                <td style={{ padding: '4px 12px', fontSize: '13px', color: '#1e293b', fontWeight: '500', whiteSpace: 'nowrap' }}>{invdetail.ItemName}</td>
                                                <td style={{ padding: '4px 12px', fontSize: '13px', width: '10%', textAlign: 'center', backgroundColor: invdetail.Quantity > invdetail.BalStock ? '#fee2e2' : 'inherit' }}>
                                                    <input
                                                        type="number"
                                                        value={invdetail.Quantity}
                                                        onChange={(e) => handleCalculation(e, index)}
                                                        className="modern-input"
                                                        style={{ maxWidth: '120px', textAlign: 'right', height: '30px', fontWeight: '600', fontSize: '13px' }}
                                                        name="Quantity"
                                                    />
                                                </td>
                                                <td style={{ padding: '4px 12px', fontSize: '13px', width: '10%', textAlign: 'center', fontWeight: '600', color: '#1e293b' }}>{invdetail.Rate}</td>
                                                <td style={{ padding: '4px 12px', fontSize: '13px', width: '10%', textAlign: 'center', fontWeight: '600', color: '#1e293b' }}>{invdetail.DiscountPer}</td>
                                                <td style={{ padding: '4px 12px', fontSize: '13px', width: '10%', textAlign: 'center', fontWeight: '600', color: '#1e293b' }}>
                                                    {typeof invdetail.TotalAmount === 'number' ? invdetail.TotalAmount.toFixed(2) : invdetail.TotalAmount}
                                                </td>
                                                <td style={{ padding: '4px 12px', fontSize: '13px', width: '30%', textAlign: 'center', backgroundColor: invdetail.Quantity > invdetail.BalStock ? '#fee2e2' : 'inherit' }}>
                                                    <input
                                                        type="text"
                                                        value={invdetail.description}
                                                        onChange={(e) => handleCalculation(e, index)}
                                                        className="modern-input"
                                                        style={{ maxWidth: '3120px', textAlign: 'left', height: '30px', fontSize: '13px' }}
                                                        name="description"
                                                    />
                                                </td>

                                                <td style={{ padding: '4px 12px', width: '15%', textAlign: 'center' }}>

                                                    {hasDeleteTransactionPermission && (
                                                        <IconButton
                                                            style={{ padding: '6px' }}
                                                            onClick={() => removeRecord(index)}
                                                        >
                                                            <DeleteIcon style={{ color: '#ef4444', fontSize: '18px' }} />
                                                        </IconButton>
                                                    )}

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </TableContainer>
                        </div>
                </div >
            </div >
        </Fragment >

    );
};

export default SaleEdit;
